module.exports = __webpack_public_path__ + "static/workflow-categories-sm-64e014e3a707e4b06d513da068104e11.png";